<router-outlet> </router-outlet>

<app-auth-modal></app-auth-modal>

<app-access-denied-modal></app-access-denied-modal>

<app-global-error-modal></app-global-error-modal>

<app-form-submit-modal></app-form-submit-modal>
